import { ColorType, FieldModifierType, ResponsiveType } from '../types';

export const FileInputColorProp: {
  [key in ColorType]: string;
} = {
  neutral: 'input-neutral',
  primary: 'input-primary',
  secondary: 'input-secondary',
  accent: 'input-accent',
  info: 'input-info',
  warning: 'input-warning',
  success: 'input-success',
  error: 'input-error',
};

export const FileInputSizerProp: {
  [key in ResponsiveType]: string;
} = {
  xs: 'input-xs',
  sm: 'input-sm',
  md: 'input-md',
  lg: 'input-lg',
};

export const FileInputModifierProp: {
  [key in FieldModifierType]: string;
} = {
  ghost: 'input-ghost',
  bordered: 'input-bordered',
};
